import React, { useRef, useState } from 'react';
import {  useIntl } from "react-intl";
const SliderDetails = (props) => {
    const { msg } = props;
    const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const intl = useIntl();
    // ✅ Flatten the nested array structure
    const getDataArray = () => {
        if (!msg) return [];
        
        // If msg is nested array like [[{...}]], flatten it
        if (Array.isArray(msg) && Array.isArray(msg[0])) {
            return msg.flat(); // This converts [[{...}]] to [{...}]
        }
        if (Array.isArray(msg) && msg.length > 0 && msg[0] && msg[0].offers) {
            return msg[0].offers;
        }
        else 
           return  msg;
    };
    
    const dataArray = getDataArray();
    const viewDetails = (link) => {
        if(link)
         window.open(link,'_blank');
    };

    const viewMoreDetails = (link) =>{
        if(link)
         window.open(link,'_blank');
    }

        const handleMouseDown = (e) => {
        setIsDragging(true);
        const slider = scrollRef.current;
        if (slider) {
            setStartX(e.pageX - slider.offsetLeft);
            setScrollLeft(slider.scrollLeft);
            slider.style.cursor = 'grabbing';
            slider.style.userSelect = 'none';
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        const slider = scrollRef.current;
        if (slider) {
            slider.style.cursor = 'grab';
            slider.style.userSelect = 'auto';
        }
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const slider = scrollRef.current;
        if (slider) {
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2;
            slider.scrollLeft = scrollLeft - walk;
        }
    };
    
   if (!dataArray || dataArray.length === 0) {
        return (

            <div className="unlimited-calls-card">
                <div className="card-content">
                    <h3 className="card-title">{intl.formatMessage({ id: "NO_DATA_FOUND" })}. </h3>
                </div>
            </div>
        );
    }
    
    return (
        <div className="services-slider-container">
            <div className="services-slider-wrapper" ref={scrollRef}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseUp} 
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
            >
                {Array.isArray(dataArray)  && dataArray.length > 0 && dataArray.map((service, index) => (
                    <div className="unlimited-calls-card" key={index}  onClick={() => service.buttonDeepLink && viewDetails(service.buttonDeepLink)}>
                        <div className="card-header-details">
                            <div className="icon-container">
                                <span className="icon">
                                    <img src={service.icon} />
                                </span>
                            </div>
                            {service.buttonText && (
                                <button className="details-button">{service.buttonText}</button>
                            )}
                        </div>
                        
                        <div className="card-content">
                            <h3 className="card-title">{service.title}</h3>
                            
                            <div className="validity-row">
                                {service.date && (
                                    <>
                                        <span className="validity-icon">
                                            <i className="fa fa-calendar"></i>
                                        </span>
                                        <span className="validity-text">{service.date}</span>
                                    </>
                                )}
                            </div>
                            
                            <div className="price-row">
                                <span className="price-amount">{service.balance || service.price}</span>
                            </div>
                        </div>
                    </div>
                ))}
                
                {/* ✅ Safe check for viewMoreDeepLink */}
                {msg && msg[0] && msg[0].viewMoreDeepLink && (
                    <div className="unlimited-calls-card"  onClick={() =>  msg[0].viewMoreDeepLink && viewMoreDetails(msg[0].viewMoreDeepLink)}>
                        <div className="card-header-details">
                            <div className="icon-container">
                                <span className="icon">
                                    <i className="fa fa-arrow-right"></i>
                                </span>
                            </div>
                        </div>
                        
                        <div className="card-content">
                            <h3 className="card-title">{intl.formatMessage({ id: "CHAT.VIEWMORE" })} </h3>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SliderDetails;